<template>
  <div>
    <BaseModal
      :id="`${$options.name}-${instanceId}`"
      data-module="whatsapp-popup"
      class="whatsapp-popup"
      :class="{ left: side == 'left' }"
      :show-on-desk="showOnDesk"
      :show-on-mobile="showOnMobile"
      :style="{
        zIndex,
        '--primary-color': primaryColor,
        '--bottom': bottom + 'px',
        '--border-radius': borderRadius + 'px',
        '--svg-size': svgSize + 'px',
      }"
    >
      <EditorLink
        :model="linkUrl"
        class="whatsapp-popup__content"
      >
        <IconWhatsApp
          color="#fff"
          :width="svgSize"
          :height="svgSize"
        />
      </EditorLink>
    </BaseModal>
    <div class="top-button text-white">
      <!-- "botão" aqui mostrado apenas como referência para o usuário-->
      <IconArrow
        direction="up"
        size="md"
      />
    </div>
  </div>
</template>

<script>
import IconWhatsApp from '@/components/icons/IconWhatsAppOutline.vue';
import IconArrow from '@/components/icons/IconArrow.vue';
import BaseModal from '../generic/modals/BaseModal.vue';
import EditorLink from '../EditorLink.vue';

export default {
  name: 'WhatsappPopup',
  components: {
    BaseModal,
    EditorLink,
    IconWhatsApp,
    IconArrow,
  },
  inheritAttrs: false,
  props: {
    ...BaseModal.props,
    instanceId: {
      type: String,
      default: '',
    },
    primaryColor: {
      type: String,
      default: '#25D366',
    },
    side: {
      type: String,
      default: 'right',
    },
    bottom: {
      type: Number,
      default: 170,
    },
    size: {
      type: Number,
      default: 60,
    },
    borderRadius: {
      type: Number,
      default: 30,
    },
    linkUrl: {
      type: Object,
      default: () => ({
        type: 'externalLink',
        value: '',
        openInNewTab: true,
      }),
    },
  },
  computed: {
    svgSize() {
      return this.size / 2;
      // a prop 'size' representa o tamanho total do ícone, que é o dobro do tamanho do svg IconWhatsApp
    },
  },
  metadata: {
    extends: BaseModal.metadata,
    tabs: [
      {
        name: 'content',
        groups: [
          {
            name: 'config',
            label: 'Configurações',
            fields: [
              {
                name: 'linkUrl',
                availableTypes: ['externalLink'],
                label: 'URL do link',
                type: 'Url',
                helpText:
                  'Saiba como criar link para o whatsapp <a href="https://faq.whatsapp.com/5913398998672934/" target="_blank">aqui</a>',
                validation: {
                  presence: {
                    allowEmpty: false,
                    message: 'Adicione um link de Whatsapp',
                  },
                },
              },
            ],
          },
        ],
      },
      {
        name: 'appearance',
        label: 'Aparência',
        groups: [
          {
            name: 'colors',
            label: 'Cores',
            fields: [
              {
                name: 'primaryColor',
                type: 'ColorPicker',
                label: 'Cor do botão',
              },
            ],
          },
          {
            name: 'dimensions',
            label: 'Dimensões',
            fields: [
              {
                name: 'size',
                label: 'Tamanho do botão',
                type: 'Range',
                min: 40,
                max: 120,
                step: 1,
                format: {
                  suffix: 'px',
                },
              },
              {
                name: 'borderRadius',
                label: 'Arrendondamento das bordas',
                type: 'Range',
                min: 0,
                max: 60,
                step: 1,
                format: {
                  suffix: 'px',
                },
              },
            ],
          },
          {
            name: 'position',
            label: 'Posicionamento',
            fields: [
              {
                name: 'side',
                type: 'VueSelect',
                label: 'Posição horizontal',
                options: [
                  {
                    label: 'Esquerda',
                    value: 'left',
                  },
                  {
                    label: 'Direita',
                    value: 'right',
                  },
                ],
              },
              {
                name: 'bottom',
                label: 'Posição vertical',
                helpText:
                  'Contagem a partir da borda inferior da janela do navegador.',
                type: 'Range',
                min: 0,
                max: 300,
                step: 1,
                format: {
                  suffix: 'px',
                },
              },
            ],
          },
        ],
      },
    ],
  },
};
</script>

<style scoped lang="scss">
.whatsapp-popup {
  position: absolute;
  right: 20px;
  bottom: var(--bottom);

  &__content {
    display: block;
    background-color: var(--primary-color);
    border-radius: var(--border-radius);
    padding: calc(var(--svg-size) / 2);
  }

  &.left {
    left: 20px;
    right: unset;
  }
}

.top-button {
  background: rgba(34, 34, 34, 0.3);
  font-size: 26px;
  position: absolute;
  right: 20px;
  bottom: 100px;
  width: 50px;
  height: 50px;
  z-index: 1;
}
</style>
